module.exports = __webpack_public_path__ + "static/media/survey-avg-rec-score-icon.e0c474b3.svg";